import { TranslationObject } from '../../i18n/translation';

const namespace = 'practiceplaceprofile';

const translations: TranslationObject = {
  title: {
    id: `${namespace}.title`,
    nb: '{practicePlaceName}',
    en: '{practicePlaceName}',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'Praksisstedprofil',
    en: 'Practice place profile',
  },
  tilbake: {
    id: `${namespace}.tilbake`,
    nb: 'Til praksissteder',
    en: 'To practice places',
  },
  avbryt: {
    id: `${namespace}.avbryt`,
    nb: 'Avbryt',
    en: 'Cancel',
  },
  endre: {
    id: `${namespace}.endre`,
    nb: 'Endre',
    en: 'Edit',
  },
  lagre: {
    id: `${namespace}.lagre`,
    nb: 'Lagre',
    en: 'Save',
  },
  lagret: {
    id: `${namespace}.lagret`,
    nb: 'Profil lagret',
    en: 'Profile saved',
  },
  profileImgAltText: {
    id: `${namespace}.profileImgAltText`,
    nb: 'Profilbilde',
    en: 'Profile picture',
  },
  profileImgName: {
    id: `${namespace}.profileImgName`,
    nb: '{practiceplaceName} profilbilde',
    en: '{practiceplaceName} profile image',
  },
  profileImgUploadLabelPrefix: {
    id: `${namespace}.pdfFileInputLabelPrefix`,
    nb: 'Dra og slipp et bilde her, eller ',
    en: 'Drag and drop an image here, or ',
  },
  profileImgUploadLabelLink: {
    id: `${namespace}.pdfFileInputLabelLink`,
    nb: 'klikk her for å velge et bilde fra datamaskinen.',
    en: 'or click here to choose an image from the computer.',
  },
  profileImgMaxSizeDescription: {
    id: `${namespace}.profileImgMaxSizeDescription`,
    nb: 'Maks. filstørrelse er {maxSize} MB.',
    en: 'Max. file size is {maxSize} MB.',
  },
  profileImgFormatsDescription: {
    id: `${namespace}.profileImgFileFormatsDescription`,
    nb: 'Gyldige filtyper er {filetypes}.',
    en: 'Accepted filetypes are {filetypes}.',
  },
  profileImgAspectRatioDescription: {
    id: `${namespace}.profileImgAspectRatioDescription`,
    nb: 'Anbefalt sideformat er {aspectRatio}.',
    en: 'Recommended aspect ratio is {aspectRatio}.',
  },
  eier: {
    id: `${namespace}.eier`,
    nb: 'Eier',
    en: 'Owner',
  },
  organisasjon: {
    id: `${namespace}.organisasjon`,
    nb: 'Organisasjon',
    en: 'Organization',
  },
  orgnr: {
    id: `${namespace}.orgnr`,
    nb: 'Orgnr',
    en: 'Organization number',
  },
  adresse: {
    id: `${namespace}.adresse`,
    nb: 'Adresse',
    en: 'Address',
  },
  adresselinje1: {
    id: `${namespace}.adresselinje1`,
    nb: 'Adresselinje 1',
    en: 'Address line 1',
  },
  adresselinje2: {
    id: `${namespace}.adresselinje2`,
    nb: 'Adresselinje 2',
    en: 'Address line 2',
  },
  postnr: {
    id: `${namespace}.postnr`,
    nb: 'Postnr',
    en: 'Zip Code',
  },
  poststed: {
    id: `${namespace}.poststed`,
    nb: 'Poststed',
    en: 'City',
  },
  goto: {
    id: `${namespace}.goto`,
    nb: 'Gå til',
    en: 'Go to',
  },
  kontaktinfo: {
    id: `${namespace}.kontaktinfo`,
    nb: 'Kontaktinformasjon',
    en: 'Contact information',
  },
  epost: {
    id: `${namespace}.epost`,
    nb: 'Epost',
    en: 'Email',
  },
  telefon: {
    id: `${namespace}.telefon`,
    nb: 'Telefonnr.',
    en: 'Phone no.',
  },
  landnr: {
    id: `${namespace}.landnr`,
    nb: 'Landnr.',
    en: 'Country no.',
  },
  nettside: {
    id: `${namespace}.nettside`,
    nb: 'Webside',
    en: 'Web site',
  },
  beskrivelse: {
    id: `${namespace}.beskrivelse`,
    nb: 'Beskrivelse',
    en: 'Description',
  },
  krav: {
    id: `${namespace}.krav`,
    nb: 'Krav til studenter',
    en: 'Requirements for students',
  },
  praksissteder: {
    id: `${namespace}.praksissteder`,
    nb: 'Praksissteder',
    en: 'Places',
  },
  lesMer: {
    id: `${namespace}.lesMer`,
    nb: 'Les mer',
    en: 'Read more',
  },
  bildeLagret: {
    id: `${namespace}.bildeLagret`,
    nb: 'Bilde lagret',
    en: 'Image saved',
  },
  bildeSlettet: {
    id: `${namespace}.bildeSlettet`,
    nb: 'Bilde slettet',
    en: 'Image deleted',
  },
  bilde: {
    id: `${namespace}.bilde`,
    nb: 'Bilde',
    en: 'Image',
  },
  lastOpp: {
    id: `${namespace}.lastOpp`,
    nb: 'Last opp',
    en: 'Upload',
  },
  slettBilde: {
    id: `${namespace}.slettBilde`,
    nb: 'Slett bilde',
    en: 'Delete Image',
  },
  endreProfil: {
    id: `${namespace}.endreProfil`,
    nb: 'Endre kontaktinformasjon',
    en: 'Edit profile information',
  },
  endreInfoTitle: {
    id: `${namespace}.endreInfoTitle`,
    nb: 'Endre kontaktdetaljer',
    en: 'Change contact details',
  },
  endreInfoSubtitle: {
    id: `${namespace}.endreInfoSubtitle`,
    nb: 'Endre kontaktinformasjon til praksisstedet. Det kan ta tid før det oppdateres',
    en: 'Make changes to contact details for this practice place. It may take some time to update changes',
  },
  submit: {
    id: `${namespace}.submit`,
    nb: 'Bekreft endring',
    en: 'Save changes',
  },
  tilbakeStudent: {
    id: `${namespace}.tilbakeStudent`,
    nb: 'Til dashbord',
    en: 'To dashboard',
  },
  // For user table
  brukerrettighet: {
    id: `${namespace}.brukerrettighet`,
    nb: 'Rolle',
    en: 'Role',
  },
  status: {
    id: `${namespace}.status`,
    nb: 'Status',
    en: 'Status',
  },
  navn: {
    id: `${namespace}.navn`,
    nb: 'Navn',
    en: 'Name',
  },
  opprettetAv: {
    id: `${namespace}.opprettetAv`,
    nb: 'Opprettet av institusjon',
    en: 'Invited by institution',
  },
  rolleAdministrator: {
    id: `${namespace}.rolleAdministrator`,
    nb: 'Administrator',
    en: 'Administrator',
  },
  rolleSkriverettighet: {
    id: `${namespace}.rolleSkriverettighet`,
    nb: 'Skriverettighet',
    en: 'Write access',
  },
  rolleLeserettighet: {
    id: `${namespace}.rolleLeserettighet`,
    nb: 'Leserettighet',
    en: 'Read access',
  },
  statusAktiv: {
    id: `${namespace}.statusAktiv`,
    nb: 'Aktiv',
    en: 'Active',
  },
  statusDeaktivert: {
    id: `${namespace}.statusDeaktivert`,
    nb: 'Deaktivert',
    en: 'Deactivated',
  },
  statusPlaceholder: {
    id: `${namespace}.statusPlaceholder`,
    nb: 'Invitert',
    en: 'Invited',
  },
  praksisstedbrukere: {
    id: `${namespace}.praksisstedbrukere`,
    nb: 'Praksisstedbrukere',
    en: 'Users at practice place',
  },
  praksisstedbrukereSubtitle: {
    id: `${namespace}.praksisstedbrukereSubtitle`,
    nb: 'Viser alle registrerte brukere med tilgang til dette praksisstednivået',
    en: 'Shows all registered users with access to this practice place level',
  },
  emptyPraksisstedbrukere: {
    id: `${namespace}.emptyPraksisstedbrukere`,
    nb: 'Finner ingen praksisstedbrukere',
    en: 'No users',
  },
  emptyPraksisstedbrukereSubtitle: {
    id: `${namespace}.emptyPraksisstedbrukereSubtitle`,
    nb: 'Det finnes ingen registrerte brukere ved dette praksisstednivået.',
    en: "There's no registered users at this practice place level.",
  },
  lastEditedBy: {
    id: `${namespace}.lastEditedBy`,
    nb: 'Sist redigert av {name}',
    en: 'Last edited by {name}',
  },
};

export default translations;
